const RESULT_MATCHED = "已匹配";
const RESULT_UNMATCHED = "未匹配";
const RESULT_MULTI = "匹配到多条";
const RESULT_MISSING_TARGET = "未找到目标产品";
const RESULT_NO_SKU = "未找到SKU";
const APPEND_HEADERS = ["转换产品名称", "转换颜色", "转换型号", "转换SKU", "转换店铺", "匹配结果"];
const CONVERT_PAIRS = [
  ["透明花熊（成都）", "透明花熊"],
  ["基础透明（成都）", "基础透明"],
  ["基础磁吸（成都）", "基础磁吸"],
  ["磨砂基础磁吸（成都）", "磨砂基础磁吸"],
  ["方形纯色透明（成都）", "方形纯色透明"],
  ["方形纯色透明（成都调色）", "方形纯色透明（调色）"],
  ["磁吸方形透明（成都）", "磁吸方形透明"],
  ["磁吸方形透明（成都调色）", "磁吸方形透明（调色）"],
];
const PREVIEW_LIMIT = 8;

function cellText(value) {
  return value == null ? "" : String(value).trim();
}

export function normalizeConvertHeader(value) {
  return cellText(value).toLowerCase().replace(/[\s\-]/g, "");
}

export function normalizeConvertKey(value) {
  return cellText(value)
    .toLowerCase()
    .replace(/（/g, "(")
    .replace(/）/g, ")")
    .replace(/[\s\-]/g, "");
}

export function findConvertHeaderIndex(headers, aliases) {
  const aliasList = aliases.map(alias => normalizeConvertHeader(alias));
  for (let i = 0; i < aliasList.length; i++) {
    const alias = aliasList[i];
    for (let col = 0; col < headers.length; col++) {
      if (normalizeConvertHeader(headers[col]) === alias) {
        return col;
      }
    }
  }
  return -1;
}

const CONVERT_NAME_MAP = new Map();
CONVERT_PAIRS.forEach(pair => {
  CONVERT_NAME_MAP.set(normalizeConvertKey(pair[0]), pair[1]);
});

export function resolveTargetName(name) {
  return CONVERT_NAME_MAP.get(normalizeConvertKey(name)) || "";
}

export function isConvertibleSourceName(name) {
  return CONVERT_NAME_MAP.has(normalizeConvertKey(name));
}

export function parseProductJsonArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (value == null || value === "") {
    return [];
  }
  if (typeof value !== "string") {
    return [];
  }
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

function pushUniqueAlias(aliases, seen, value) {
  const text = cellText(value);
  if (!text) {
    return;
  }
  const key = normalizeConvertKey(text);
  if (seen.has(key)) {
    return;
  }
  seen.add(key);
  aliases.push(text);
}

export function buildConvertIndex(products, colors) {
  const index = new Map();
  const colorList = Array.isArray(colors) ? colors : [];
  (products || []).forEach(product => {
    const productName = cellText(product.productName);
    const checkColors = parseProductJsonArray(product.checkColors);
    const checkModels = parseProductJsonArray(product.checkModels);
    const purchaseColors = parseProductJsonArray(product.purchaseColors);
    const colorKeys = checkColors.length ? checkColors : [""];
    const modelList = checkModels.length ? checkModels : [""];
    colorKeys.forEach(colorKey => {
      const colorMeta = colorList.find(color => color.key == colorKey);
      const purchase = purchaseColors.find(item => item && item.productColor == colorKey);
      const colorName = cellText((colorMeta && colorMeta.name) || (purchase && purchase.purchaseColorName) || colorKey);
      const aliases = [];
      const seen = new Set();
      pushUniqueAlias(aliases, seen, colorKey);
      pushUniqueAlias(aliases, seen, colorName);
      pushUniqueAlias(aliases, seen, purchase && purchase.purchaseColorName);
      pushUniqueAlias(aliases, seen, colorMeta && colorMeta.jpKey);
      if (!aliases.length) {
        aliases.push("");
      }
      modelList.forEach(model => {
        const modelText = model == null ? "" : String(model);
        const match = {
          productType: product.productType,
          productName,
          shopName: cellText(product.shopName),
          skuPrefix: cellText(product.skuPrefix),
          colorKey: colorKey == null ? "" : String(colorKey),
          colorName,
          model: modelText,
        };
        aliases.forEach(alias => {
          const key = [normalizeConvertKey(productName), normalizeConvertKey(alias), normalizeConvertKey(modelText)].join("|");
          if (!index.has(key)) {
            index.set(key, []);
          }
          const list = index.get(key);
          const duplicated = list.some(item => item.productType === match.productType && normalizeConvertKey(item.colorName) === normalizeConvertKey(match.colorName) && normalizeConvertKey(item.model) === normalizeConvertKey(match.model));
          if (!duplicated) {
            list.push(match);
          }
        });
      });
    });
  });
  return index;
}

function sameShop(left, right) {
  const shop = cellText(left).toLowerCase();
  const other = cellText(right).toLowerCase();
  return !!shop && shop === other;
}

function narrowByShop(items, shopName, readShop) {
  if (!cellText(shopName) || !items || items.length <= 1) {
    return items || [];
  }
  const matched = items.filter(item => sameShop(readShop(item), shopName));
  return matched.length ? matched : items;
}

function longestSkuPrefix(product, sku) {
  const skuText = cellText(sku).toLowerCase();
  let best = "";
  [product && product.skuPrefix, product && product.skuPrefix2].forEach(prefix => {
    const prefixText = cellText(prefix);
    if (!prefixText || !skuText || skuText.indexOf(prefixText.toLowerCase()) !== 0) {
      return;
    }
    if (prefixText.length > best.length) {
      best = prefixText;
    }
  });
  return best;
}

export function parseSkuTail(sku, prefix) {
  const skuText = cellText(sku);
  const prefixText = cellText(prefix);
  if (!skuText || !prefixText || skuText.toLowerCase().indexOf(prefixText.toLowerCase()) !== 0) {
    return { colorKey: "", model: "" };
  }
  const rest = skuText.slice(prefixText.length).replace(/^-+/, "");
  if (!rest) {
    return { colorKey: "", model: "" };
  }
  const dash = rest.lastIndexOf("-");
  if (dash <= 0) {
    return { colorKey: rest, model: "" };
  }
  return {
    colorKey: rest.slice(0, dash),
    model: rest.slice(dash + 1),
  };
}

function finishSource(candidates, shopName, productNameFromRow) {
  let narrowed = narrowByShop(candidates, shopName, item => item.product.shopName);
  if (narrowed.length > 1) {
    const nameKey = normalizeConvertKey(productNameFromRow);
    if (nameKey) {
      const byName = narrowed.filter(item => normalizeConvertKey(item.product.productName) === nameKey);
      if (byName.length) {
        narrowed = byName;
      }
    }
  }
  if (narrowed.length === 1) {
    return { parent: narrowed[0].product, prefix: narrowed[0].prefix, multi: false };
  }
  if (narrowed.length > 1) {
    return { parent: null, prefix: "", multi: true };
  }
  return { parent: null, prefix: "", multi: false };
}

export function findChengduSource(products, sku, productNameFromRow, shopName) {
  const skuText = cellText(sku).toLowerCase();
  let bestLen = 0;
  let candidates = [];
  if (skuText) {
    (products || []).forEach(product => {
      if (!isConvertibleSourceName(product.productName)) {
        return;
      }
      [product.skuPrefix, product.skuPrefix2].forEach(prefix => {
        const prefixText = cellText(prefix);
        const prefixKey = prefixText.toLowerCase();
        if (!prefixKey || skuText.indexOf(prefixKey) !== 0) {
          return;
        }
        if (prefixKey.length > bestLen) {
          bestLen = prefixKey.length;
          candidates = [{ product, prefix: prefixText }];
          return;
        }
        if (prefixKey.length === bestLen && !candidates.some(item => item.product === product)) {
          candidates.push({ product, prefix: prefixText });
        }
      });
    });
  }
  if (candidates.length) {
    return finishSource(candidates, shopName, productNameFromRow);
  }
  const nameKey = normalizeConvertKey(productNameFromRow);
  if (!nameKey) {
    return { parent: null, prefix: "", multi: false };
  }
  const byName = (products || [])
    .filter(product => isConvertibleSourceName(product.productName) && normalizeConvertKey(product.productName) === nameKey)
    .map(product => ({ product, prefix: longestSkuPrefix(product, sku) }));
  return finishSource(byName, shopName, productNameFromRow);
}

function emptyMatch(result, targetName, targetExists) {
  return {
    name: "",
    color: "",
    model: "",
    sku: "",
    result,
    targetName: targetName || "",
    targetExists: !!targetExists,
    productType: "",
    colorKey: "",
    shopName: "",
  };
}

function lookupTargetHits(index, targetKey, color, model) {
  if (!cellText(color)) {
    return [];
  }
  const key = [targetKey, normalizeConvertKey(color), normalizeConvertKey(model)].join("|");
  return (index.get(key) || []).filter(item => normalizeConvertKey(item.productName) === targetKey && !isConvertibleSourceName(item.productName));
}

function dedupeHits(hits) {
  const list = [];
  hits.forEach(hit => {
    const exists = list.some(item => item.productType === hit.productType && item.colorKey === hit.colorKey && normalizeConvertKey(item.model) === normalizeConvertKey(hit.model));
    if (!exists) {
      list.push(hit);
    }
  });
  return list;
}

function toMatched(hit, targetName) {
  return {
    name: hit.productName,
    color: hit.colorName,
    model: hit.model,
    sku: "",
    result: RESULT_MATCHED,
    targetName,
    targetExists: true,
    productType: hit.productType,
    colorKey: hit.colorKey,
    shopName: hit.shopName,
  };
}

export function matchConvertRow(products, source, rowColor, rowModel, shopName, index) {
  if (source.multi) {
    return emptyMatch(RESULT_MULTI);
  }
  if (!source.parent) {
    return emptyMatch(RESULT_UNMATCHED);
  }
  const targetName = resolveTargetName(source.parent.productName);
  const targetKey = normalizeConvertKey(targetName);
  const targetExists = !!targetName && (products || []).some(product => normalizeConvertKey(product.productName) === targetKey && !isConvertibleSourceName(product.productName));
  if (!targetExists) {
    return emptyMatch(RESULT_MISSING_TARGET, targetName, false);
  }
  const parsed = parseSkuTail(source.sku, source.prefix);
  const pairs = [
    [parsed.colorKey, parsed.model],
    [parsed.colorKey, rowModel],
    [rowColor, parsed.model],
    [rowColor, rowModel],
  ];
  let hits = [];
  for (let i = 0; i < pairs.length; i++) {
    hits = dedupeHits(lookupTargetHits(index, targetKey, pairs[i][0], pairs[i][1]));
    if (hits.length) {
      break;
    }
  }
  hits = narrowByShop(hits, shopName, item => item.shopName);
  if (hits.length === 1) {
    return toMatched(hits[0], targetName);
  }
  if (hits.length > 1) {
    return emptyMatch(RESULT_MULTI, targetName, true);
  }
  return emptyMatch(RESULT_UNMATCHED, targetName, true);
}

function trimHeaders(headers) {
  let end = headers.length;
  while (end > 0 && cellText(headers[end - 1]) === "") {
    end -= 1;
  }
  return headers.slice(0, end).map(header => cellText(header));
}

export function buildConvertSheet(matrix, products, colors) {
  const productList = Array.isArray(products) ? products : [];
  if (!productList.length) {
    return { error: "请先查询父产品列表" };
  }
  if (!matrix || !matrix.length) {
    return { error: "表格没有数据" };
  }
  const headers = trimHeaders(matrix[0] || []);
  if (!headers.length) {
    return { error: "表格没有表头" };
  }
  const skuIndex = findConvertHeaderIndex(headers, ["sku", "sellersku"]);
  const colorIndex = findConvertHeaderIndex(headers, ["产品颜色", "采购颜色", "颜色", "productcolor", "color"]);
  const modelIndex = findConvertHeaderIndex(headers, ["机型", "型号", "model"]);
  const nameIndex = findConvertHeaderIndex(headers, ["产品名称", "产品名", "productname"]);
  const shopIndex = findConvertHeaderIndex(headers, ["店铺", "店铺名称", "shopname", "shop"]);
  if (skuIndex < 0 || colorIndex < 0 || modelIndex < 0) {
    return { error: "请确保表格包含 SKU、产品颜色、机型列" };
  }
  const dataRows = matrix.slice(1).filter(row => (row || []).some(cell => cellText(cell) !== ""));
  if (!dataRows.length) {
    return { error: "表格没有数据行" };
  }

  const index = buildConvertIndex(productList, colors);
  const outputHeaders = headers.concat(APPEND_HEADERS);
  const outputRows = [];
  const rowMeta = [];
  const preview = [];
  const neededTargets = new Set();
  const existingTargets = new Set();
  let matched = 0;
  let unmatched = 0;
  let multi = 0;

  dataRows.forEach(row => {
    const cells = headers.map((_, col) => (row[col] == null ? "" : row[col]));
    const shopName = shopIndex >= 0 ? cells[shopIndex] : "";
    const source = findChengduSource(productList, cells[skuIndex], nameIndex >= 0 ? cells[nameIndex] : "", shopName);
    source.sku = cells[skuIndex];
    const info = matchConvertRow(productList, source, cells[colorIndex], cells[modelIndex], shopName, index);
    if (info.targetName) {
      neededTargets.add(info.targetName);
      if (info.targetExists) {
        existingTargets.add(info.targetName);
      }
    }
    if (info.result === RESULT_MATCHED) {
      matched += 1;
    } else if (info.result === RESULT_MULTI) {
      multi += 1;
    } else {
      unmatched += 1;
    }
    outputRows.push(cells.concat([info.name, info.color, info.model, info.sku, info.result === RESULT_MATCHED ? info.shopName : "", info.result]));
    rowMeta.push({
      productType: info.productType || "",
      colorKey: info.colorKey || "",
      colorName: info.color || "",
      model: info.model || "",
      shopName: info.shopName || shopName,
      sourceSku: cellText(cells[skuIndex]),
      sourceColor: cellText(cells[colorIndex]),
      sourceModel: cellText(cells[modelIndex]),
      result: info.result,
    });
    if (info.result !== RESULT_MATCHED && preview.length < PREVIEW_LIMIT) {
      preview.push({
        sku: cellText(cells[skuIndex]),
        color: cellText(cells[colorIndex]),
        model: cellText(cells[modelIndex]),
        result: info.result,
      });
    }
  });

  if (neededTargets.size > 0 && existingTargets.size === 0) {
    return { error: "列表中没有「" + Array.from(neededTargets).join("、") + "」，无法转换" };
  }

  return {
    headers: outputHeaders,
    rows: outputRows,
    rowMeta,
    summary: {
      total: outputRows.length,
      matched,
      unmatched,
      multi,
    },
    preview,
  };
}

function childColorMatches(child, meta) {
  const colorKey = normalizeConvertKey(meta.colorKey);
  const colorName = normalizeConvertKey(meta.colorName);
  const childKey = normalizeConvertKey(child.productColor);
  const childName = normalizeConvertKey(child.productColorName);
  if (colorKey && (childKey === colorKey || childName === colorKey)) {
    return true;
  }
  if (colorName && (childName === colorName || childKey === colorName)) {
    return true;
  }
  return false;
}

function preferListingMatches(matches) {
  const listing = matches.filter(item => !/-P\d*$/i.test(item.sku));
  return listing.length ? listing : matches;
}

function findChildMatches(children, meta) {
  const hits = (children || []).filter(child => child.productType == meta.productType && childColorMatches(child, meta) && normalizeConvertKey(child.model) === normalizeConvertKey(meta.model));
  const narrowed = narrowByShop(hits, meta.shopName, child => child.shopName);
  const matches = [];
  narrowed.forEach(child => {
    const sku = cellText(child["seller-sku"]);
    if (!sku || matches.some(item => item.sku === sku)) {
      return;
    }
    matches.push({
      sku,
      shopName: cellText(child.shopName) || meta.shopName || "",
    });
  });
  return preferListingMatches(matches);
}

function recountConvertSheet(built) {
  const resultCol = built.headers.lastIndexOf("匹配结果");
  const preview = [];
  let matched = 0;
  let unmatched = 0;
  let multi = 0;
  built.rows.forEach((row, index) => {
    const result = row[resultCol];
    if (result === RESULT_MATCHED) {
      matched += 1;
    } else if (result === RESULT_MULTI) {
      multi += 1;
    } else {
      unmatched += 1;
    }
    const meta = built.rowMeta[index] || {};
    if (result !== RESULT_MATCHED && preview.length < PREVIEW_LIMIT) {
      preview.push({
        sku: meta.sourceSku || "",
        color: meta.sourceColor || "",
        model: meta.sourceModel || "",
        result,
      });
    }
  });
  built.summary = {
    total: built.rows.length,
    matched,
    unmatched,
    multi,
  };
  built.preview = preview;
  return built;
}

export function attachChildSkus(built, childProducts) {
  if (!built || built.error) {
    return built;
  }
  const skuCol = built.headers.lastIndexOf("转换SKU");
  const shopCol = built.headers.lastIndexOf("转换店铺");
  const resultCol = built.headers.lastIndexOf("匹配结果");
  built.rows.forEach((row, index) => {
    const meta = built.rowMeta[index];
    if (!meta || meta.result !== RESULT_MATCHED) {
      return;
    }
    const matches = findChildMatches(childProducts, meta);
    if (matches.length === 1) {
      row[skuCol] = matches[0].sku;
      row[shopCol] = matches[0].shopName || row[shopCol];
      row[resultCol] = RESULT_MATCHED;
      return;
    }
    row[skuCol] = "";
    row[resultCol] = matches.length > 1 ? RESULT_MULTI : RESULT_NO_SKU;
  });
  return recountConvertSheet(built);
}
